module.exports = __webpack_public_path__ + "img/image (13).569837e5.jpg";